import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UnskipStepForLead as UnskipStepForLeadMutation,
    UnskipStepForLeadVariables,
    StepUnskipInput,
} from 'nutshell-graphql-types';

import UNSKIP_STEP_FOR_LEAD from '../mutations/unskip-step-for-lead.graphql';

export const useUnskipStepForLead = (): {
    unskipStepForLead: (arg1: StepUnskipInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [unskipStepForLead, {loading, error}] = useMutation<
        UnskipStepForLeadMutation,
        UnskipStepForLeadVariables
    >(UNSKIP_STEP_FOR_LEAD);

    return {
        unskipStepForLead: (input: StepUnskipInput) => unskipStepForLead({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
